/*
-------------------------------------------------------------------------------------
Authors         : Alinsonorin, John Myl B., Awi, Joseph Kahl L., Gozon, Daniel Allan
Date Created    : Jul 27, 2025
Folder          : src/components/button
File            : ButtonCompDark.tsx
Description     : 
    This reusable component is a dark button.
Copyright © 2025. All rights reserved.
-------------------------------------------------------------------------------------
*/


// Import React Systems
import React, { useEffect, useState } from 'react'
import { Link } from "react-router-dom";

// Imports MUI Components
import { Link as MuiLink, Tooltip } from '@mui/material'
import { Button, Typography } from '@mui/material'
import { alignContent, alignItems, justifyItems, margin, textAlign } from '@mui/system'

// Import Firebase
import { onAuthStateChanged } from 'firebase/auth'
import app, { auth, db } from "../../../../backend/firebaseConfig"
import { get, getDatabase, ref } from 'firebase/database'

// Import Assets
import dashboard from "../../../../assets/dashboard.png"
import settings from "../../../../assets/settings.png"
import history from "../../../../assets/treatment_history.png"
import inventory from "../../../../assets/invent.png"
import analytics from "../../../../assets/analytics.png"
import manage from "../../../../assets/manage.png"
import services from "../../../../assets/services.png"

import './styles.css'

const SidebarButtonsComp = ({ 
  color,
  text,
  img,
  hover,
  open
}) => {

  // Styling for the button
  const style = {
    color: "#FDF9F3",
    backgroundColor: color,
    borderRadius: 
      open ? "50px 0 0 50px" :
      "20px",
    justifyContent: 
      open ? "start" :
      "center",
    textTransform: "none",
    padding: "10px 15px",
    width: "100%",
    margin: "8px 0",
    '&:hover': {
      backgroundColor: hover,
    },
    "& .MuiButton-startIcon" : {
      mr: !open ? "0px" : null,
      ml: !open ? "0px" : null,
    },
    transition: "0.3s ease-in"
  }

  return (
    <div>
      <Tooltip
        title={
          open ? null : 
          text
        }
        placement="right"
        arrow
      >
        <Button
          variant='contained'
          disableElevation
          sx={style}
          disableRipple
          startIcon={
          img === "dashboard" ? (
            <img
              src={dashboard}
              alt="dashboard"
              className="button-icons" />
          ) : img === "settings" ? (
            <img 
              src={settings}
              alt="settings"
              className="button-icons" />
          ) : img === "inventory" ? (
            <img 
              src={inventory}
              alt="inventory"
              className="button-icons" />
          ) : img === "analytics" ? (
            <img 
              src={analytics}
              alt="analytics"
              className="button-icons" />
          ) : img === "services" ? (
            <img 
              src={services}
              alt="services"
              className="button-icons" />
          ) : img === "manage" ? (
            <img 
              src={manage}
              alt="manage-personnel"
              className="button-icons" />
          ) : (
            <img 
              src={history}
              alt="history"
              className="button-icons" />
          )
        }>

          {open && 
          <Typography
            variant="body1"
            sx={{
              color: "#FDF9F3",
              fontWeight: "300",
              fontSize: "14px",
              padding: "10px 15px",
              transition: "font-size 0.2s",
            }}>{text}
          </Typography>
          }

        </Button>
      </Tooltip>
    </div>
  )
}

export default SidebarButtonsComp
